import { IconActionChevronUp24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './ToTopButton.css';

interface IToTopButtonProps {
  onClick: VoidFunction;
}

export const ToTopButton: FC<IToTopButtonProps> = ({ onClick }) => {
  return (
    <button className={styles['to-top-button']} onClick={onClick}>
      <IconActionChevronUp24 color="icon-main-default" />
    </button>
  );
};
